import axios from 'axios';
import moment from 'moment';
import { constructServiceURL } from '../../../../../utils/URLTools';

const apiFetchFluxVolumeOeReport = (payload) => {
  const serviceUrl = constructServiceURL({
    endpoint: 'getFluxVolumeOeReport',
    stub: process.env.useStubbedEndpoints,
    pathParameters: {
      appContext: payload.appContext,
    },
  });
  return axios.post(serviceUrl, {
    endDate: moment(payload.params.endDate).format('YYYY-MM-DD'),
    focals: payload.params.focals,
    startDate: moment(payload.params.startDate).format('YYYY-MM-DD'),
    targets: payload.params.targets,
  });
};

export default apiFetchFluxVolumeOeReport;
